import { render, staticRenderFns } from "./NaoxjStockSaleEditSn.vue?vue&type=template&id=2516726e&scoped=true&"
import script from "./NaoxjStockSaleEditSn.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockSaleEditSn.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockSaleEditSn.vue?vue&type=style&index=0&id=2516726e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516726e",
  null
  
)

export default component.exports